import { createValidationSchema, emailField, isError, assertRateLimit, MINUTE_TO_MS, runUnsafe, NotFoundError, } from "@for-it/domain-lib";
import { UserEntity } from "../../entities/user.js";
const DEFAULT_LANG = "es";
export const requestPasswordReset = {
    name: "requestPasswordReset",
    description: "A user requests a password reset. This use case sends an email with a token to the user. The token is used to reset the password.",
    type: "command",
    payloadSchema: createValidationSchema({
        email: emailField({ required: true, message: "Must be a valid email" }),
    }),
    useCase: async ({ db, crypto, emails, lang, time, env, }, { email }) => {
        const user = await db.findOneBy(UserEntity, { email });
        if (!user) {
            return new NotFoundError();
        }
        if (user.passwordResetAttemptsCount != 0) {
            const limit = await assertRateLimit(user.passwordResetAttemptsCount, user.passwordResetTokenUpdatedAt, MINUTE_TO_MS * 1);
            if (isError(limit)) {
                return limit;
            }
        }
        const randomToken = await runUnsafe(crypto.generateRandomToken());
        user.passwordResetToken = randomToken;
        user.passwordResetAttemptsCount += 1;
        user.passwordResetTokenUpdatedAt = time.now();
        await db.update(UserEntity, user.id, user);
        await emails.sendTemplateEmail({
            template: "PASSWORD_RESET",
            to: [user.email],
            lang: lang || DEFAULT_LANG,
            data: {
                email: user.email,
                firstName: user.firstName,
                lastName: user.lastName,
                token: randomToken,
                resetUrl: `${env.get("WEB_HOST")}/set-new-password?email=${encodeURIComponent(user.email)}&token=${randomToken}`,
            },
        });
    },
};
